import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../../../../../environments/environment';
import { HeaderBasicAuthorizationService } from '../../../../../shared/services/header-basic-authorization.service';
import { ApiEnum } from '../../../../../shared/enums/api.enum';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CargaMasivaService {

  constructor(
    private http: HttpClient,
    private headerBasicAuthorization: HeaderBasicAuthorizationService
  ) {
  }

  private blobType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=UTF-8';

  listar() {
    return this.http.get(`${environment.api.WS_HCM.url}/CargaMasiva/Listar`,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  descargar(cargaMasiva: number): any {
    return this.http.get(`${environment.api.WS_HCM.url}/CargaMasiva/Descargar?cargaMasiva=${cargaMasiva}`,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  descargarDetalle(detalleCargaMasiva: number): any {
    return this.http.get(`${environment.api.WS_HCM.url}/CargaMasiva/DescargarDetalle?detalleCargaMasiva=${detalleCargaMasiva}`,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  descargarBase64(base64, name) {
    const blob: Blob = this.base64toBlob(base64);
      const url = window.URL.createObjectURL(blob);
      const dlink = document.createElement('a');
          dlink.download = name;
          dlink.href = url;
      dlink.click();
      dlink.remove();
  }

  private base64toBlob(b64Data, sliceSize=512): Blob {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, {type: this.blobType});
    return blob;
  }

  public CargaMasivaTareoAgricola(datos): Observable<any> {
    return this.http.post(`${environment.api.WS_HCM.url}/CargaMasiva/CargaMasivaTareoAgricola`, datos,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public getTareoAgricola(model): Observable<any> {
    return this.http.post(`${environment.api.WS_HCM.url}/CargaMasiva/getTareoAgricola`, model,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public getCargaDataPlantilla() {
    return this.http.get(`${environment.api.WS_HCM.url}/CargaMasiva/getCargaDatosPlantilla`,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }
}
